<template>
  <with-configuration-tabs>
    <div class="curation fixed-heading scrollable">
      <div class="heading">
        <h1>Curation</h1>
        <p class="guide_text">Add new actors, delete old actors and accept or reject new
          claims by clicking the links below.</p>
        <tabs :tabs="tabs" :saveToUrl="true" :tab-counters="tabCounters">
          <template v-slot:[tabNames.newActors]>
            <div>
              <p>
                Curate new actor profiles
              </p>
              <div class="row">
                <form-group class="col-sm-4 col-md-3" label="Filter by name">
                  <ds-input v-model="filters.name"/>
                </form-group>
              </div>
            </div>
          </template>
          <template v-slot:[tabNames.deletedActors]>
            <div>
              <p>
                Overview of removed actor profiles
              </p>
              <div class="row">
                <form-group class="col-sm-4 col-md-3" label="Filter by name">
                  <ds-input v-model="filters.name"/>
                </form-group>
              </div>
            </div>
          </template>
          <template v-slot:[tabNames.claims]>
            <div>
              <p>
                Accept or reject actor claims
              </p>
              <div class="row">
                <form-group class="col-sm-4 col-md-3" label="Filter by name">
                  <ds-input v-model="filters.name"/>
                </form-group>
              </div>
            </div>
          </template>
          <template v-slot:[tabNames.resources]>
            <div>
              <p>
                Accept or reject uploaded content
              </p>
              <div class="row">
                <form-group class="col-sm-4 col-md-3" label="Filter by title">
                  <ds-input v-model="filters.name"/>
                </form-group>
              </div>
            </div>
          </template>
          <template v-slot:[tabNames.knowledgeBase]>
            <div>
              <p>
                Accept or reject knowledge base posts
              </p>
              <div class="row">
                <form-group class="col-sm-4 col-md-3" label="Filter by title">
                  <ds-input v-model="filters.name"/>
                </form-group>
              </div>
            </div>
          </template>
        </tabs>
      </div>

      <div class="has-pagination" v-if="activeTab == 'Resources'">
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th style="width:100px;">Created by</th>
            <th style="width:150px;">Community</th>
            <th style="width:80px;">Created at</th>
            <th colspan="3" style="width:400px;">Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <row-curation-file
            v-for="(entry, index) in content" :key="index"
            :content="entry" @ok="handleRemove(entry)"
          />
          </tbody>
        </table>
      </div>

      <div class="has-pagination" v-else-if="activeTab === 'Knowledge Base'">
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th style="width:100px;">Created by</th>
            <th style="width:150px;">Community</th>
            <th style="width:80px;">Created at</th>
            <th colspan="3" style="width:400px;">Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <row-curation-knowledge-base
            v-for="(post, index) in knowledgeBasePosts" :key="index"
            :post="post" 
            @approved="handleKnowledgeBaseApproval(post)"
            @rejected="handleKnowledgeBaseRejection(post)"
            @preview="previewKnowledgeBasePost(post)"
          />
          </tbody>
        </table>
      </div>

      <div class="has-pagination" v-else-if="activeTab === 'Challenges'">
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th style="width:300px">Title</th>
            <th style="width:150px">Created by</th>
            <th style="width:250px">Community</th>
            <th style="width:100px">Created at</th>
            <th colspan="4" style="width:500px;">Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <row-curation-challenge
            v-for="(challenge, index) in challenges"
            :key="index"
            :challenge="challenge"
          />
          </tbody>
        </table>
      </div>

      <div class="has-pagination" v-else-if="activeTab === 'Community Requests'">
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th style="width:300px">User</th>
            <th style="width:250px">Community</th>
            <th style="width:100px">Created at</th>
            <th colspan="4" style="width:500px;">Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <CommunityJoinRequestCurationRow
            v-for="(communityJoinRequest, index) in communityJoinRequests"
            :key="index"
            :communityJoinRequest="communityJoinRequest"
          />
          </tbody>
        </table>
      </div>

      <div class="has-pagination" v-else-if="activeTab === 'Deleted Actors'">
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th>Name</th>
            <th>Actor created at</th>
            <th>Claimed</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <row-curation
            v-for="(actor, index) in actors" :key="index" :actor="actor"
            @ok="handleRemove(actor)"
            :is-deleted-tab="true"
          />
          </tbody>
        </table>
      </div>

      <div class="has-pagination" v-else-if="['Add to map'].includes(activeTab)">
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th>Name</th>
            <th>Actor created at</th>
            <th>Portfolio</th>
            <th style="display: flex;">
              Claim status
            </th>
            <th v-if="(this.isOwner || this.isMember)" colspan="3" style="width:300px;">Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <row-curation-portfolio-actors
            v-for="(actor, index) in actors" :key="index" :actor="actor"
            @ok="fetch"
          />
          </tbody>
        </table>
      </div>

      <div class="has-pagination" v-else-if="['New Actors', 'Claims'].includes(activeTab)">
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th>Name</th>
            <th>Actor created at</th>
            <th>Portfolio</th>
            <th style="display: flex;">
              Claim status
            </th>
            <th v-if="(this.isOwner || this.isMember)" colspan="3" style="width:300px;">Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <row-curation
            v-for="(actor, index) in actors" :key="index" :actor="actor"
            @ok="handleRemove(actor)"
          />
          </tbody>
        </table>
      </div>

      <div class="has-pagination" v-else>
        <table class="table table--fill table--hover" style="table-layout: fixed">
          <thead>
          <tr>
            <th style="width:300px">Title</th>
            <th style="width:150px">Created by</th>
            <th style="width:250px">Community</th>
            <th style="width:100px">Created at</th>
            <th colspan="4" style="width:500px;">Actions</th>
          </tr>
          </thead>
          <tbody @click="$root.curating = true">
          <row-curation-announcement
            v-for="(announcement, index) in announcements"
            :key="index" :announcement="announcement"
          />
          </tbody>
        </table>
      </div>
      <pagination class="simple-pagination--bottom" :paging="paging" @change="setOffset"/>
    </div>
  </with-configuration-tabs>
</template>

<script lang="ts">
  import Checkbox from '../Form/Checkbox.vue'
  import DsInput from '../Form/DsInput.vue'
  import FormGroup from '../Form/FormGroup.vue'
  import Pagination from '../Pagination/SimplePagination.vue'
  import RowCuration from './RowCuration.vue'
  import RowCurationAnnouncement from './RowCurationAnnouncement.vue'
  import RowCurationChallenge from './RowCurationChallenge.vue'
  import RowCurationFile from './RowCurationFile.vue'
  import RowCurationKnowledgeBase from './RowCurationKnowledgeBase.vue'
  import Tabs from '../Tabs/Tabs.vue'

  import { fetchCuration } from '../../api/curation.js'

  import WithConfigurationTabs from '../../pages/WithConfigurationTabs/WithConfigurationTabs.vue'
  import TranslationsMixin from '../../util/TranslationsMixin.js'
  import { defineComponent } from 'vue'
  import CommunityJoinRequestCurationRow from '@/components/Datalab/CommunityJoinRequestCurationRow.vue'
  import UserMixin from '@/util/UserMixin'
  import RowCurationPortfolioActors from '@/components/Datalab/RowCurationPortfolioActors.vue'

  export default defineComponent({
    components: {
      RowCurationPortfolioActors,
      CommunityJoinRequestCurationRow,
      Checkbox,
      DsInput,
      FormGroup,
      Pagination,
      RowCuration,
      RowCurationAnnouncement,
      RowCurationChallenge,
      RowCurationFile,
      RowCurationKnowledgeBase,
      Tabs,
      WithConfigurationTabs,
    },
    props: ['company'],
    data() {
      return {
        actors: [],
        announcements: [],
        challenges: [],
        communityJoinRequests: [],
        portfolioActors: [],
        content: [],
        knowledgeBasePosts: [],
        paging: null,
        filters: {
          name: null,
          type: 'draft',
          limit: 20,
          offset: 0,
        },
        curationCount: null,
        activeTab: 'New Actors',
        tabNames: {
          newActors: 'New Actors',
          communityJoinRequests: 'Community Requests',
          deletedActors: 'Deleted Actors',
          claims: 'Claims',
          announcements: 'Announcements',
          resources: 'Resources',
          challenges: 'Challenges',
          portfolioActors: 'Add to map',
          knowledgeBase: 'Knowledge Base',
        },
      }
    },
    computed: {
      knowledgePanelEnabled() {
        return (this.$store.state.config.viewDashboard || []).includes('knowledge-base')
      },
      tabCounters() {
        if (!this.curationCount) {
          return null
        }
        let result = [this.curationCount.draft, this.curationCount.portfolio, this.curationCount.deleted, this.curationCount.claim, this.curationCount.announcements]

        if (this.isPortfolioMember) {
          result = [this.curationCount.announcements]
        }

        if (this.areCommunitiesEnabled) {
          result.push(this.curationCount.communityJoinRequests)
        }

        if (this.knowledgePanelEnabled) {
          result.push(this.curationCount.content)
          result.push(this.curationCount.knowledgeBase)
        }
        if (this.$store.state.config.challengesAreEnabled) {
          result.push(this.curationCount.challenges)
        }
        return result
      },
      areCommunitiesEnabled(): boolean {
        return this.$store.getters.hasAccessToCommunities
      },
      tabs() {
        var tabs = [this.tabNames.newActors, this.tabNames.portfolioActors, this.tabNames.deletedActors, this.tabNames.claims, this.tabNames.announcements]

        if (this.isPortfolioMember) {
          tabs = [this.tabNames.announcements]
        }

        if (this.areCommunitiesEnabled) {
          // Portfolio members that have access to the curation will manage at least 1 community, so no need to check for the portfolio member role
          tabs = tabs.concat(this.tabNames.communityJoinRequests)
        }

        if (this.knowledgePanelEnabled) {
          tabs = tabs.concat(this.tabNames.resources)
          tabs = tabs.concat(this.tabNames.knowledgeBase)
        }

        if (this.$store.state.config.challengesAreEnabled) {
          tabs = tabs.concat(this.tabNames.challenges)
        }

        return tabs
      },
    },
    methods: {
      fetchCurationCount() {
        fetchCuration(Object.assign({}, { type: 'count-all' }))
          .then(({ data }) => {
            this.curationCount = data
          }, this.fetchError)
      },
      fetch() {
        this.fetchCurationCount()
        let type = 'claim'

        switch (this.activeTab) {
          case this.tabNames.announcements:
            type = 'announcements'
            break
          case this.tabNames.communityJoinRequests:
            type = 'communityJoinRequests'
            break
          case this.tabNames.challenges:
            type = 'challenges'
            break
          case this.tabNames.newActors:
            type = 'draft'
            break
          case this.tabNames.deletedActors:
            type = 'deleted'
            break
          case this.tabNames.resources:
            type = 'content'
            break
          case this.tabNames.knowledgeBase:
            type = 'knowledgeBase'
            break
          case this.tabNames.portfolioActors:
            type = 'portfolio'
            break;
          default:
            break
        }

        if (type === 'announcements') {
          fetchCuration(Object.assign({}, { type: type }))
            .then(({ data, paging }) => {
              this.announcements = data
              this.paging = paging
            }, this.fetchError)
        } else if (type === 'challenges') {
          fetchCuration(Object.assign({}, { type: type }))
            .then(({ data, paging }) => {
              this.challenges = data
              this.paging = paging
            }, this.fetchError)
        } else if (type == 'content') {
          fetchCuration(Object.assign({}, { type: type }))
            .then(({ data, paging }) => {
              this.content = data
              this.paging = paging
            }, this.fetchError)
        } else if (type == 'knowledgeBase') {
          fetchCuration(Object.assign({}, { type: type, name: this.filters.name }))
            .then(({ data, paging }) => {
              this.knowledgeBasePosts = data
              this.paging = paging
            }, this.fetchError)
        } else if (type == 'communityJoinRequests') {
          fetchCuration(Object.assign({}, { type: type }))
            .then(({ data, paging }) => {
              this.communityJoinRequests = data
              this.paging = paging
            }, this.fetchError)
        } else if (type == 'portfolioActors') {
          fetchCuration(Object.assign({}, { type: type }))
            .then(({ data, paging }) => {
              this.portfolioActors = data
              this.paging = paging
            }, this.fetchError)
        } else {
          fetchCuration(Object.assign({}, this.filters, { type: type }))
            .then(({ data, paging }) => {
              this.actors = data
              this.paging = paging
            }, this.fetchError)
        }
      },
      fetchError(error) {
        console.log('fetched error', error)
      },
      setOffset(offset) {
        this.filters.offset = offset
      },
      handleKnowledgeBaseApproval(post) {
        // Remove the post from the pending list
        const index = this.knowledgeBasePosts.findIndex(p => p.id === post.id)
        if (index !== -1) {
          this.knowledgeBasePosts.splice(index, 1)
        }
        // Refresh if no posts left
        if (this.knowledgeBasePosts.length === 0) {
          this.fetch()
        }
      },
      handleKnowledgeBaseRejection(post) {
        // Remove the post from the pending list
        const index = this.knowledgeBasePosts.findIndex(p => p.id === post.id)
        if (index !== -1) {
          this.knowledgeBasePosts.splice(index, 1)
        }
        // Refresh if no posts left
        if (this.knowledgeBasePosts.length === 0) {
          this.fetch()
        }
      },
      previewKnowledgeBasePost(post) {
        // Open the post in a new tab for preview
        const url = post.community_id 
          ? `/communities/${post.community_id}/knowledge-base/posts/${post.id}`
          : `/knowledge-base/posts/${post.id}`
        window.open(url, '_blank')
      },
      handleRemove(actor) {
        if (this.activeTab === this.tabNames.deletedActors || this.activeTab === this.tabNames.newActors) {
          this.actors.splice(this.actors.indexOf(actor), 1)
          if (this.actors.length === 0) {
            this.fetch()
          }
        }
      },
    },
    created() {
      this.$bus.on('tab', (tab) => {
        this.activeTab = tab

        this.actors = []
        this.paging = null

        this.fetch()
      })

      this.$bus.on('editAndAcceptedAnnouncement', () => {
        this.fetch()
      })

      this.$bus.on('acceptedAnnouncement', () => {
        this.fetch()
      })

      this.$bus.on('deniedAnnouncement', () => {
        this.fetch()
      })

      this.$bus.on('challengeUpdated', () => {
        this.fetch()
      })

      this.$bus.on('acceptedChallenge', () => {
        this.fetch()
      })

      this.$bus.on('deniedChallenge', () => {
        this.fetch()
      })

      this.$bus.on('refreshCurationResults', () => {
        setTimeout(() => {
          this.fetch()
        }, 1500)
      })
    },
    beforeUnmount() {
      this.$bus.off('tab')
      this.$bus.off('editAndAcceptedAnnouncement')
      this.$bus.off('acceptedAnnouncement')
      this.$bus.off('deniedAnnouncement')
      this.$bus.off('challengeUpdated')
      this.$bus.off('acceptedChallenge')
      this.$bus.off('deniedChallenge')
      this.$bus.off('refreshCurationResults')
    },
    mixins: [TranslationsMixin, UserMixin],
    watch: {
      filters: {
        deep: true,
        handler(a, b) {
          this.fetch()
        },
      },
    }
  })
</script>

<style lang="scss">
  .curation {
    > .heading {
      padding-bottom: 0;
    }

    .tabs__navigation {
      padding-top: 1em;
      margin-bottom: 0;
    }
  }
</style>
